import React from 'react';
export const Badge = ({
  children,
  className = ''
}: any) => <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-zano-lavender text-zano-charcoal ${className}`} data-id="element-2437" data-mp="1hra71fadrcuk">
    {children}
  </span>;